import autocapture from '@/providers/statsig/plugins/autocapture';

export default [autocapture];
